// Content Security Policy — dedicated Recent Violations page.
// See Config.js — this is a thin wrapper that gates the shared
// CspConfig implementation to the "violations" section only.

import React from "react";
import CspConfig from "./Config";

export default function CspViolations() {
  return <CspConfig section="violations" />;
}
